// extracted by extract-css-chunks-webpack-plugin
module.exports = {"swiper":"swiper_sNUdZ"};